import type { TunaThunkDispatch } from '@tunasong/redux'
import { entitiesApi } from '@tunasong/redux'

/** The entity id of an entity route (`/app/e/:entityId/*`), or null for any other route */
export const getRouteEntityId = (pathname: string) => {
  const id = pathname.match(/^\/app\/e\/([^/?#]+)/)?.[1] ?? null
  return id === 'ROOT' ? null : id
}

/**
 * Start loading the route's entity, its children and its edges as soon as the session is known (GH #1543).
 *
 * The entity page issues these three requests on every load, but only once the app shell — the plugin
 * collection and the lazy route chunk — has rendered it, although the id is in the URL from the start. The
 * args match what the graph hooks pass, so the hooks pick up these queries instead of starting their own.
 */
export const prefetchRouteEntity = (dispatch: TunaThunkDispatch, pathname: string) => {
  const id = getRouteEntityId(pathname)
  if (!id) {
    return
  }
  dispatch(entitiesApi.util.prefetch('loadEntity', { id }, {}))
  dispatch(entitiesApi.util.prefetch('loadChildEntities', { parentId: id }, {}))
  dispatch(entitiesApi.util.prefetch('loadEntityEdges', { source: id }, {}))
}
